import { IController, IComponentOptions } from 'angular';


export class ArmorySlaShimController implements IController {
  public application: any;
  constructor() {
    if (!this.application.slaDefinitions) {
      this.application.slaDefinitions = [];
    }
    this.updateSLADefinitions = this.updateSLADefinitions.bind(this);
  }

  public updateSLADefinitions(slaDefinitions: any) {
    this.application.slaDefinitions = slaDefinitions;
  }
}

export class ArmorySlaShimComponentOptions implements IComponentOptions {
  public controller: any = ArmorySlaShimController;
  public controllerAs = 'ctrl';
  public templateUrl: string = require('./shim.template.html');
  public bindings: any = {
    application: '=',
  };
}
